import React from 'react';

// SVG Edge-4 opção 4
const IconQLogo = (props) => (
  <svg
    {...props}
    viewBox="0 0 192 192"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    fill="currentColor"
  >
    <g transform="translate(0,192) scale(0.1,-0.1)" stroke="none">
      <path d="M845 1794 c-219 -26 -411 -131 -548 -299 -59 -73 -139 -236 -162 -327 -18 -76 -21 -260
      -6 -349 43 -252 197 -467 423 -588 137 -74 252 -103 401 -102 157 2 314 47 438 126 30 19 62 35
      72 35 11 0 49 -29 86 -65 l68 -65 86 0 c76 0 87 2 87 17 0 10 -107 125 -237 255 -178 178 -232 238
      -216 238 30 0 57 42 89 136 23 71 26 90 21 179 -5 123 -29 191 -98 280 -40 52 -49 72 -49 104 0 50
      -37 96 -90 112 -34 10 -44 9 -80 -9 -38 -18 -48 -19 -102 -9 -128 24 -313 -32 -414 -124 -55 -51 -119
      -146 -136 -201 -7 -23 -25 -48 -44 -63 -54 -41 -55 -113 -3 -155 10 -8 26 -41 34 -73 26 -100 65 -167
      140 -242 39 -38 77 -85 84 -103 25 -60 73 -77 133 -46 24 12 56 16 122 15 107 -2 187 16 265 60 l54 31
      76 -76 76 -76 -37 0 c-24 0 -61 -13 -100 -34 -116 -63 -187 -81 -328 -80 -108 0 -136 4 -205 27 -113
      38 -196 90 -280 178 -125 131 -188 295 -184 479 3 114 21 189 70 286 88 178 260 314 452 359 98 23 282
      14 375 -19 135 -47 249 -130 326 -240 94 -132 130 -241 129 -391 0 -124 -20 -204 -79 -312 -24 -46 -44
      -89 -44 -97 0 -14 93 -106 109 -106 27 0 121 188 151 305 30 112 30 298 1 410 -110 418 -486 670 -926
      619z m202 -409 c14 -3 24 -16 28 -37 14 -64 69 -100 136 -88 35 7 42 4 68 -22 83 -85 122 -255 87 -383
      -13 -51 -62 -155 -72 -155 -3 0 -32 25 -65 57 -40 38 -59 64 -59 80 0 109 -126 163 -194 82 -61 -72 -11
      -179 82 -179 21 0 44 -16 91 -64 l64 -64 -39 -20 c-67 -34 -145 -52 -226 -52 -72 0 -79 2 -87 23 -18 46
      -46 60 -105 54 -55 -5 -55 -5 -103 42 -54 54 -99 130 -118 202 -12 44 -11 49 4 54 46 14 58 108 20 146
      -19 19 -20 25 -10 59 14 48 86 147 132 181 101 77 253 112 366 84z"/>
    </g>
  </svg>
);

export default IconQLogo;
